import React from 'react'
import styles from '../../layout.module.scss'
import { useNavigate } from 'react-router-dom'
import { MagnifyingGlassIcon, PencilIcon, BriefcaseIcon } from '@heroicons/react/24/solid'
import { useIsMobile } from '../../../hooks'

// 골프 아이콘 컴포넌트
const GolfIcon = ({ style }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		strokeLinejoin="round"
		style={style}>
		<path stroke="none" d="M0 0h24v24H0z" fill="none" />
		<path d="M12 18v-15l7 4l-7 4" />
		<path d="M9 17.67c-.62 .36 -1 .82 -1 1.33c0 1.1 1.8 2 4 2s4 -.9 4 -2c0 -.5 -.38 -.97 -1 -1.33" />
	</svg>
)

export const ButtonBox = ({ userType }) => {
	const navigate = useNavigate()
	const isMobile = useIsMobile()
	if (userType === 'tourPro') {
		return (
			<div className={styles.buttonBox}>
				<button className={styles.btnGrn} onClick={() => navigate('/posts/create/type')}>
					<PencilIcon style={{ width: '12px', height: '12px', color: 'white' }} />
					<span>공고작성</span>
				</button>
				<button className={styles.btnBlack} onClick={() => navigate('/search')}>
					<MagnifyingGlassIcon
						style={{ width: '12px', height: '12px', color: 'white' }}
					/>
					<span>캐디 찾기</span>
				</button>
				{!isMobile && (
					<button className={styles.btnGreen} onClick={() => navigate('/home')}>
						<GolfIcon style={{ width: '14px', height: '14px', color: 'white' }} />
						<span>마이페이지</span>
					</button>
				)}
			</div>
		)
	} else if (userType === 'tourCaddie') {
		return (
			<div className={styles.buttonBox}>
				<button className={styles.btnGrn} onClick={() => navigate('/posts')}>
					<BriefcaseIcon style={{ width: '12px', height: '12px', color: 'white' }} />
					<span>공고 지원하기</span>
				</button>
				<button className={styles.btnBlack} onClick={() => navigate('/search')}>
					<MagnifyingGlassIcon
						style={{ width: '12px', height: '12px', color: 'white' }}
					/>
					<span>프로 찾기</span>
				</button>
				{!isMobile && (
					<button className={styles.btnGreen} onClick={() => navigate('/home')}>
						<GolfIcon style={{ width: '14px', height: '14px', color: 'white' }} />
						<span>마이페이지</span>
					</button>
				)}
			</div>
		)
	} else {
		return (
			<div className={styles.buttonBox}>
				<button className={styles.btnGreenBorder} onClick={() => navigate('/login')}>
					로그인
				</button>
				<button className={styles.btnGreen2} onClick={() => navigate('/signup')}>
					회원가입
				</button>
			</div>
		)
	}
}
